<template>
    <v-card class="mx-auto">
        <v-snackbar
          v-model="showErr"
          multi-line
          :timeout="3000"
          top
          :color="errCode==0?'success':''"
        >
          {{ errMsg }}
          <template v-slot:action="{ attrs }">
            <v-btn
              :color="errCode==0?'':'red'"
              text
              v-bind="attrs"
              @click.prevent.stop="showErr = false"
            >
              close
            </v-btn>
          </template>
        </v-snackbar>
        <v-card-title class="text-center align-center d-flex justify-center">
                <h4>Remote Control</h4>
        </v-card-title>
        <v-card-text class="justify-center text-center">
            <v-row>
                <v-spacer/>
                <v-col >
                    <v-btn fab @click="()=>{touchControl('playfirst','',result=>chkReplyErr(result))}">
                        <v-icon>
                            mdi-page-first
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn fab @click="()=>{touchControl('playlast','',result=>chkReplyErr(result))}">
                        <v-icon>
                            mdi-page-last
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-spacer/>
            </v-row>
        </v-card-text>
        <v-card-text class="justify-center text-center mb-6">
            <v-row>
                <v-spacer/>
                <v-col>
                    <v-btn fab @click="()=>{touchControl('playprev','',result=>chkReplyErr(result))}">
                        <v-icon>
                            mdi-chevron-left 
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn fab @click="()=>{touchControl('playnext','',result=>chkReplyErr(result))}">
                        <v-icon>
                            mdi-chevron-right 
                        </v-icon>
                    </v-btn>
                </v-col>
                <v-spacer/>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
//import Remote from '@/views/Remote'
export default {
    name:"SSTV",
    data(){
        return {
            device:{},
            errCode:0,
            dropUrlDuration:null,
            setLogoUrl:'',
            startcmd:null,
            startcmd_droplast: true,
            startcmd_dropurl: false,
            droplastChanged: true,
            dropLastDelay:null,
            dropUrls:[],
            dropUrlMode:'',
            startEventDDN:'',
            startEventTopic:'',
            startEventPayload:'',
            errMsg:'',
            showErr:false,
            showScreenSetting:false,
            showConsole:false,
            enableStartupEvent:true,
            settingEiName:'',
            settingEiTag:'',
            settingEiLoc:'',
            showSetting:false,
            ddn:this.$route.params.ddn,
            rcerr:{
                "OK":{"code":0,"msg":"OK"},
                "Error":{"code":-499,"msg":"rc: error"},
                "InvalidData":{"code":-401,"msg":"rc: invalid data"},
                "InvalidCmd":{"code":-402,"msg":"rc: invalid command"},
                "Inactive":{"code":-403,"msg":"rc: mote inactive"},
                "MMSError":{"code":-404,"msg":"rc: mms error"}
            }
        }
    },
    props:['mms','mmsReady'],
    mixins:[],
    watch:{
        mmsReady(val){
            
        }
    },
    methods:{
        touchControl(action, value, cb){
            var tcmd = {"cmd":"touch","option":action,"value":value};
            if ( tcmd.option != '' ){
                let target = this.ddn;
                if ( target != '' ){
                    target = 'ddn/' + target;
                    console.log(target,tcmd);
                    //var wstr = target + ' ' + JSON.stringify(tcmd);
                    //console.log('settingControl target=%s,cmd=%s', target, JSON.stringify(tcmd));
                    this.mms.sendMMS( {DDN:target,topic:'', payload:this.isJson(tcmd)?JSON.parse(tcmd):tcmd}).then(result=>{
                        //console.log('settingControl: send result=%s',JSON.stringify(result));
                        if ( typeof cb == 'function' ) cb(result);
                    });   
                }
            }    
        },
        chkReplyErr(data){
            var err = true;
            try {
                if ( data ){
                    if ( Array.isArray(data) ) {
                        let xstate = data[0].IN.State;
                        this.errCode=xstate.ErrCode;
                        if ( xstate.ErrCode != 0 ) this.errMsg = xstate.ErrMsg;
                        else {
                            let reply = data[0].Reply;
                            if ( !reply ) this.errMsg = 'no reply data';
                            else err = false;
                        }
                    }
                    else {
                        this.errMsg = data.ErrMsg;
                    }
                }
            }
            catch(e){
                this.errMsg = e.message;
            }
            if ( err ) {
                console.log('mms error=%s', this.errMsg);
                this.showErr=true;
            }else this.errMsg='Ok';
            
            return err;
        }
    },
    async created(){
    }
}
</script>




